import { render } from "./CooperationManageView.vue?vue&type=template&id=61959e94&scoped=true"
import script from "./CooperationManageView.vue?vue&type=script&lang=js"
export * from "./CooperationManageView.vue?vue&type=script&lang=js"

import "./CooperationManageView.vue?vue&type=style&index=0&id=61959e94&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61959e94"]])

export default __exports__